import { styled, Theme } from '@mui/material/styles';
import { DRAWER_WIDTH, LayoutType } from 'utils/constants';

type MainStyleProps = {
  theme: Theme;
  open: boolean;
  layout: string;
};

// ==============================|| COMPONENT ||============================== //

export const Main = styled('main', {
  shouldForwardProp: (prop) => prop !== 'open'
})(({ theme, open, layout }: MainStyleProps) => ({
  ...theme.typography.mainContent,
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
  ...(!open && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.shorter + 200
    }),
    [theme.breakpoints.up('md')]: {
      marginLeft:
        layout === LayoutType.VERTICAL_LAYOUT ? -(DRAWER_WIDTH - 72) : '20px',
      width: `calc(100% - ${DRAWER_WIDTH}px)`,
      marginTop: layout === LayoutType.HORIZONTAL_LAYOUT ? 135 : 80
    },
    [theme.breakpoints.down('md')]: {
      marginLeft: '20px',
      width: `calc(100% - ${DRAWER_WIDTH}px)`,
      padding: '16px',
      marginTop: 88
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: '10px',
      width: `calc(100% - ${DRAWER_WIDTH}px)`,
      padding: '16px',
      marginRight: '10px',
      marginTop: 88
    }
  }),
  ...(open && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.shorter + 200
    }),
    marginLeft: layout === LayoutType.HORIZONTAL_LAYOUT ? '20px' : 0,
    marginTop: layout === LayoutType.HORIZONTAL_LAYOUT ? 135 : 80,
    width: `calc(100% - ${DRAWER_WIDTH}px)`,
    [theme.breakpoints.up('md')]: {
      marginTop: layout === LayoutType.HORIZONTAL_LAYOUT ? 135 : 80
    },
    [theme.breakpoints.down('md')]: {
      marginLeft: '20px',
      marginTop: 80
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: '10px',
      marginTop: 80
    }
  })
}));
